(function () {
  var applicationSettingsControllerId = "applicationSettingsController";

  angular
    .module("app")
    .controller(applicationSettingsControllerId, ["$window", "$rootScope", "$scope", "$location", "$filter", "routingProfile", "alkModalService", "UserProvider", "optionsUI", "_", 
      "$timeout", "routeService", "conversionService", "defaultDimensions", "applicationSettingsService",
      function ($window, $rootScope, $scope, $location, filter, routingProfile, alkModalService, userProvider, optionsUI, _, $timeout, routeService, conversionService, defaultDimensions, applicationSettingsService) {
        var vm = this;
        vm.title = "Application Settings";
        vm.optionsUI = optionsUI;
        vm.appSettingCopy = angular.copy(routingProfile.getDefaultOptions());
        vm.useTollDiscounts = (vm.appSettingCopy.tollPlan === "All") ? true : false;
        vm.supported = false;
        vm.isAlertShowing = false;
        vm.alertMessage = "";
        vm.userIsPremium = userProvider.getUser().isPremium();
        vm.region = userProvider.getUser().region;
        vm.tollCurrencyChanged = tollCurrencyChanged;
        vm.changeUnits = changeUnits;
        vm.afterUnitChange = afterUnitChange;
        vm.ok = ok;
        vm.tollCurrencyStr = tollCurrencyStr;
        vm.resetToDefaults = resetToDefaults;
        vm.cancel = cancel;
        vm.userCfg = {
          classicSearchView: applicationSettingsService.getUserCfg("classicSearchView"),
          includePOI: applicationSettingsService.getUserCfg("includePOI")
        };

        ////////////////////////////////////
        function tollCurrencyChanged() {
          vm.appSettingCopy.exchangeRate = _.find(vm.optionsUI.tollCurrency, function (item) { return item.value === vm.appSettingCopy.tollCurrency; }).exchangeRate;
        }

        function changeUnits() {
          vm.appSettingCopy = applicationSettingsService.changeUnits(vm.appSettingCopy);
        }

        function afterUnitChange()
        {
          if (vm.region === "EU" && vm.appSettingCopy.distanceUnits === 1 && vm.appSettingCopy.fuelUnits === 1) {
            vm.appSettingCopy.EUFuelEconLoad = (100 / vm.appSettingCopy.fuelEconLoad).toFixed(2);
          }
        }

        function tollCurrencyStr() {
          return _.find(vm.optionsUI.tollCurrencyEU, {
            value: vm.appSettingCopy.tollCurrency
          }).display;
        }

        // toll discounts can only be enabled if includeTollData is true
        $scope.$watch("vm.appSettingCopy.inclTollData", () => {
          if (vm.appSettingCopy.inclTollData === false) {
            vm.useTollDiscounts = false;
          }
        });

        $scope.$watch("vm.userCfg.classicSearchView", () => {
          if (vm.userCfg.classicSearchView === true) {
            vm.userCfg.includePOI = false;
          }
        });

        // for EU customers with metric distance unit and liter fuel unit, auto convert liters Per 100 kms to fuelEconLoad
        $scope.$watch("vm.appSettingCopy.EUFuelEconLoad", (newValue, oldValue) => {
          if (vm.region === "EU" && vm.appSettingCopy.distanceUnits === 1 && vm.appSettingCopy.fuelUnits === 1) {
            // code first initialized, calculate EUFuelEconLoad from fuelEconLoad value
            if (!newValue && !oldValue) {
              vm.appSettingCopy.EUFuelEconLoad = (100 / vm.appSettingCopy.fuelEconLoad).toFixed(2);
              return;
            }
            vm.appSettingCopy.fuelEconLoad = (100 / vm.appSettingCopy.EUFuelEconLoad).toFixed(2);
          }
        });

        function ok() {
          if (vm.appSettingCopy.trkUnits === 0) {
            if (Array.isArray(vm.appSettingCopy.trkLength)) {
              vm.appSettingCopy.trkLength = conversionService.feetInchesToString(vm.appSettingCopy.trkLength);
              vm.appSettingCopy.trkHeight = conversionService.feetInchesToString(vm.appSettingCopy.trkHeight);
            }
            if (vm.region === "EU" && Array.isArray(vm.appSettingCopy.EUOptions.trlMaxHt)) {
              vm.appSettingCopy.EUOptions.trlMaxHt = conversionService.feetInchesToString(vm.appSettingCopy.EUOptions.trlMaxHt);
            }
          }
          vm.appSettingCopy.tollPlan = vm.useTollDiscounts ? "All" : "";
          routingProfile.setDefaultOptions(vm.appSettingCopy);
          // update route.options so that when going back to app page, all existing routes will re-run with new routing profile.
          routeService.updateAllRoutesAppSettingsOptions(vm.appSettingCopy);
          // save includePOI and classicSearchView to localStorage
          applicationSettingsService.updateUserCfg(vm.userCfg);
          vm.isAlertShowing = true;
          vm.alertMessage = "Application Settings have been updated.";
          $timeout(() => {
            vm.isAlertShowing = false;
            $location.url("/app");
          }, 1200);
        }

        function cancel() {
          if (!$scope.applicationSettingForm.$pristine) {
            alkModalService.show({
              size: "sm"
            }, {
              headerText: "Exit Application Settings",
              bodyText: "Are you sure you want to exit without saving your changes?"
            }).then(() => {
              $location.url("/app");
            });
          } else {
            $location.url("/app");
          }
        }

        function resetToDefaults() {
          var reset = applicationSettingsService.resetUserCfg();
          vm.userCfg = {
            classicSearchView: reset.classicSearchView,
            includePOI: reset.includePOI
          };
          vm.appSettingCopy = routingProfile.getSystemDefaultOptions();
          routingProfile.setDefaultOptions(vm.appSettingCopy);
          vm.useTollDiscounts = (vm.appSettingCopy.tollPlan === "All") ? true : false;
          // update route.options so that when going back to app page, all existing routes will re-run with new routing profile.
          routeService.updateAllRoutesOptions(vm.appSettingCopy);
          vm.isAlertShowing = true;
          vm.alertMessage = "Application Settings have been reset to Default.";
          $timeout(function () {
            vm.isAlertShowing = false;
          }, 1200);
        }
      }
    ]);
})();




// WEBPACK FOOTER //
// ./app/applicationSettings/applicationSettings.controller.js